import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	isUnchangeable: ForNodeType<boolean>;
	onSetViewModel: (
		values: {
			key: "isUnchangeable";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const usePlanIsUnchangeable = ({ isUnchangeable, onSetViewModel }: Props) => {
	const onSetIsUnchangeable = (value: boolean) => {
		onSetViewModel([
			{
				key: "isUnchangeable",
				value: {
					isEdited: true,
					value,
				},
			},
		]);
	};

	return {
		isUnchangeable,
		onSetIsUnchangeable,
	};
};
